import { useEffect, useState } from 'react';
import heroImg from "../assets/top.jpeg";
import kovilTop from "../assets/koviltop.jpeg";
import { GiIndianPalace } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import { Card, CardMedia, CardContent, Typography, Grid, Box } from "@mui/material";
import samplePDF from "../assets/edu.pdf";
import sivagnanaPokkisam from "../assets/sivagnanapokkisam.pdf";
import agilam from "../assets/agilam.pdf";
import Hist from "../assets/his.jpeg";
import Video1 from "../assets/video1.mp4";
import Kodimaram from "../assets/kodimaram.jpeg";
import HistoryEng from "../assets/history1eng.pdf";
import HistoryTam from "../assets/historytam.pdf";
import Historypdf from "../assets/historypdf.pdf";
import Gallery from "../components/gallery";
import Videos from "../components/videos";
import Moolamporul from "../assets/moolamporul.pdf";
import Ammanai from "../assets/cover.png";
import Book3 from "../assets/book3.jpeg";
import Sivaneyanam from "../assets/sivaneyanam.jpeg";
import Book4 from "../assets/book4.jpeg";
import English from "../assets/english.png";
import { MdCelebration, MdTempleHindu, MdTempleBuddhist, MdVolunteerActivism } from "react-icons/md";
import BookCard from './BookCard';
import BookFlip from './BookFlip';
import { Calendar, MapPin, Clock, Play } from 'lucide-react';
import InvitationPDF from "../assets/invite.pdf";
import ModiInviteImg from "../assets/modi-invite.jpeg";

function MahaKumbavisekamBanner() {
  const SHOW_UNTIL = new Date("2026-05-03T23:59:59");

  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const now = new Date();
    if (now > SHOW_UNTIL) return;
    setVisible(true);

    const calc = () => {
      const target = new Date("2026-05-01T07:00:00");
      const now = new Date();
      const diff = target - now;
      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };

    calc();
    const timer = setInterval(calc, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!visible) return null;

  const marqueeText = "🪔 மகா கும்பாபிஷேகம் — அனைவரும் வருக! · ஸ்ரீமன் வைகுண்ட நாராயணசுவாமி திருக்கோவில் · மே 01, 2026 · காலை 9:30 AM · மதகநேரி · 🙏 சகல மங்களங்களும் உண்டாகட்டும் · 🪔 மகா கும்பாபிஷேகம் — அனைவரும் வருக! · ஸ்ரீமன் வைகுண்ட நாராயணசுவாமி திருக்கோவில் · மே 01, 2026 · காலை 9:30 AM · மதகநேரி · 🙏 சகல மங்களங்களும் உண்டாகட்டும் · ";

  return (
    <div className="w-full text-white overflow-hidden" style={{ background: 'linear-gradient(to bottom, #1a2a6c, #1e3a8a)' }}>

      {/* TOP MARQUEE STRIP — orange/saffron to match temple theme */}
      <div className="py-2 overflow-hidden whitespace-nowrap relative" style={{ background: '#c2410c' }}>
        <style>{`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            display: inline-flex;
            animation: marquee 32s linear infinite;
            will-change: transform;
          }
          .marquee-track:hover {
            animation-play-state: paused;
          }
          @keyframes flipIn {
            0% { transform: rotateX(90deg); opacity: 0; }
            100% { transform: rotateX(0deg); opacity: 1; }
          }
          .flip-digit {
            animation: flipIn 0.4s ease-out;
          }
        `}</style>
        <div className="marquee-track">
          {[...Array(2)].map((_, i) => (
            <span
              key={i}
              className="text-sm font-semibold tracking-wide px-4 text-orange-100"
              style={{ fontFamily: "'Noto Sans Tamil', sans-serif" }}
            >
              {marqueeText}
            </span>
          ))}
        </div>
      </div>

      {/* MAIN BANNER */}
      <div
        className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-8"
        style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #1d4ed8 100%)' }}
      >
        {/* LEFT: Title */}
        <div className="text-center md:text-left">
          <div
            className="text-sm font-bold uppercase tracking-widest mb-2 flex items-center gap-2 justify-center md:justify-start"
            style={{ color: '#fbbf24' }}
          >
            🔔 சிறப்பு அறிவிப்பு
          </div>
          <h2
            className="text-3xl md:text-5xl font-extrabold leading-tight mb-3"
            style={{
              fontFamily: "'Noto Sans Tamil', sans-serif",
              color: '#ffffff',
              textShadow: "0 2px 20px rgba(251,191,36,0.5)"
            }}
          >
            மகா கும்பாபிஷேகம்
          </h2>
          <p
            className="text-lg md:text-xl font-semibold mb-2"
            style={{ fontFamily: "'Noto Sans Tamil', sans-serif", color: '#fde68a' }}
          >
            அனைவரும் வருக! 🙏
          </p>
          <p
            className="text-sm"
            style={{ fontFamily: "'Noto Sans Tamil', sans-serif", color: '#bfdbfe' }}
          >
            மே 01, 2026 · காலை 9:30 AM · மதகநேரி
          </p>
        </div>

        {/* RIGHT: Countdown */}
        <div className="flex flex-col items-center gap-3">
          <p
            className="text-xs font-bold uppercase tracking-widest"
            style={{ color: '#fbbf24' }}
          >
            நிகழ்வு தொடங்க இன்னும்
          </p>
          <div className="flex items-center gap-2 flex-nowrap">
            {[
              { label: "நாட்கள்", value: timeLeft.days },
              { label: "மணி", value: timeLeft.hours },
              { label: "நிமிடம்", value: timeLeft.minutes },
              { label: "விநாடி", value: timeLeft.seconds },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="flex flex-col items-center">
                  <div
                    key={item.value}
                    className="flip-digit rounded-xl w-14 h-14 md:w-18 md:h-18 flex items-center justify-center shadow-xl"
                    style={{
                      background: 'linear-gradient(145deg, #1e40af, #1e3a8a)',
                      border: '2px solid #fbbf24',
                      width: '4rem',
                      height: '4rem',
                    }}
                  >
                    <span
                      className="text-2xl md:text-3xl font-extrabold tabular-nums"
                      style={{ color: '#ffffff' }}
                    >
                      {String(item.value).padStart(2, "0")}
                    </span>
                  </div>
                  <span
                    className="text-xs mt-1.5 font-semibold"
                    style={{ fontFamily: "'Noto Sans Tamil', sans-serif", color: '#fbbf24' }}
                  >
                    {item.label}
                  </span>
                </div>
                {i < 3 && (
                  <span
                    className="text-2xl font-extrabold mb-5"
                    style={{ color: '#fbbf24' }}
                  >
                    :
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* BOTTOM STRIP */}
      <div
        className="text-center py-2 text-xs tracking-widest font-semibold uppercase"
        style={{ background: 'rgba(30, 58, 138, 0.8)', color: '#bfdbfe' }}
      >
        ✦ ஸ்ரீமன் வைகுண்ட நாராயணசுவாமி திருக்கோவில் · மகா கும்பாபிஷேக மஹோத்சவம் ✦
      </div>
    </div>
  );
}

export default function Sections() {
  const navigate = useNavigate();
  const [activeMedia, setActiveMedia] = useState('image');

  const books = [
    {
      id: 1,
      title: "தல வரலாறும் மகிமையும் (தமிழ்)",
      author: "அபிர்தமிங்கம் பிள்ளை, R. P.",
      image: Hist,
      pdf: HistoryTam,
    },
    {
      id: 2,
      title: "The History and Glory (English)",
      author: "அபிர்தமிங்கம் பிள்ளை, R. P.",
      image: English,
      pdf: HistoryEng,
    },
    {
      id: 3,
      title: "முடி புகழ்ந்த அம்மானை",
      author: "இரா. முருகேசன்",
      image: Ammanai,
      pdf: samplePDF,
    },
    {
      id: 4,
      title: "முடி புகழ்ந்த அம்மானை மூலமும் விளக்கமும்",
      author: "இரா. முருகேசன்",
      image: Book3,
      pdf: Moolamporul,
    },
    {
      id: 5,
      title: "சிவஞான பொக்கிஷம்",
      author: "இரா. முருகேசன்",
      image: Sivaneyanam,
      pdf: sivagnanaPokkisam,
    },
    {
      id: 6,
      title: "அகிலத்திரட்டு அம்மானை",
      author: "இரா. முருகேசன்",
      image: Book4,
      pdf: agilam,
    },
  ];

  const kumbhavisekam = {
    title: "மகா கும்பாபிஷேகம்",
    date: "மே 01, 2026",
    time: "காலை 9:30 AM முதல்",
    location: "மதகநெல்லூர் என்ற மதகநேரி",
    description:
      "ஸ்ரீமன் வைகுண்ட நாராயணசுவாமி திருக்கோவிலில் நடைபெறும் மகா கும்பாபிஷேக மஹோத்சவம்.மரியாதைக்குரிய பிரதமர் மோடி அவர்களுக்கு அழைப்பிதழ் வழங்கப்பட்டுள்ளது.",
    invitationPdf: InvitationPDF,
    modiImage: ModiInviteImg,
  };

  const handleClick = (path) => {
    navigate(path);
  };

  const features = [
    {
      icon: <MdTempleBuddhist className="text-white text-2xl" />,
      text: "தல வரலாறும் மகிமையும்",
      bg: "bg-sky-500",
      pdf: Historypdf
    },
    {
      icon: <MdTempleHindu className="text-white text-2xl" />,
      text: "பணிவிடைகள்",
      bg: "bg-green-600",
      path: "/poojas",
    },
    {
      icon: <MdCelebration className="text-white text-2xl" />,
      text: "திருவிழாக்கள்",
      bg: "bg-amber-700",
      path: "/festivals",
    },
    {
      icon: <MdVolunteerActivism className="text-white text-2xl" />,
      text: "நன்கொடை",
      bg: "bg-rose-700",
      path: "/donation",
    },
  ];

  const channel = {
    name: "தெய்வக் கைலாயம்",
    thumbnail: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    subscribers: "125K",
    totalViews: "15M",
    videos: 248,
    joinedDate: "Jan 2020",
    description: "வைகுண்ட நாராயணசுவாமி விருப்ப-பாடல்கள் மற்றும் புகழ்பாடல்கள்",
    about: "எங்கள் சேனலில் வைகுண்ட நாராயணசுவாமி அவர்களின் மகிமை, தெய்வீக பாடல்கள், பக்தி வழிபாடு ஆகியவற்றை தமிழில் பகிர்கிறோம்.",
    channelUrl: "https://youtube.com/channel/UCB_7HWKkKpDVGBg1tHLWLEw?si=woM0u-uOy_eizX5N",
    highlights: [
      "முடிபுகழ்ந்த அம்மானை. தொடர்-108 போன்ற பக்தி பாடல்களின் தொடர்கள்",
    ]
  };

  const event = {
    title: "கொடிமரம் பிரதிஷ்டை விழா",
    date: "ஆகஸ்ட் 03, 2025",
    time: "காலை 10:00 AM",
    location: "மதகநெல்லூர் என்ற மதகநேரி",
    description: "தமிழ் இலக்கியம் மற்றும் கலாச்சாரத்தை கொண்டாடும் ஒரு சிறப்பு நிகழ்வு.",
    image: Kodimaram,
    videoId: Video1
  };

  const CHANNEL_ID = 'UCuAXFkgsw1L7xaCfnd5JJOw';
  const embedUrl = `https://www.youtube.com/embed?listType=user_uploads&list=${CHANNEL_ID}`;

  return (
    <main className="bg-white text-black -mt-12 relative z-30">

      {/* ===== MAHA KUMBAVISEKAM BANNER — TOP OF PAGE ===== */}
      <div className="relative z-50 mt-12">
        <MahaKumbavisekamBanner />
      </div>
      {/* ===== MAHA KUMBAVISEKAM DETAIL SECTION ===== */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex items-center gap-4 mb-10">
          <div>
            {/* <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-800 rounded-full px-4 py-1.5 text-sm font-bold mb-3 tracking-wide uppercase">
              <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse inline-block" />
              விரைவில் வருகிறது · மே 01, 2026
            </div> */}
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              <span className="text-amber-600">மகா கும்பாபிஷேகம்</span>
            </h1>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

          {/* LEFT: Event Details Card */}
          <div
            className="rounded-2xl shadow-xl overflow-hidden"
            style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)', border: '1px solid #3b82f6' }}
          >
            <div className="h-2" style={{ background: 'linear-gradient(to right, #f59e0b, #ea580c, #dc2626)' }} />
            <div className="p-8">
              <div
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 mb-6 text-sm font-bold shadow"
                style={{ background: '#ea580c', color: '#fff' }}
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                சிறப்பு மஹோத்சவம்
              </div>

              <h2
                className="text-xl font-bold mb-6 leading-relaxed"
                style={{ color: '#e0f2fe', fontFamily: "'Noto Sans Tamil', sans-serif" }}
              >
                {kumbhavisekam.description}
              </h2>

              <div className="space-y-4 mb-8">
                {[
                  { icon: <Calendar className="w-5 h-5" />, label: "தேதி", value: kumbhavisekam.date },
                  { icon: <Clock className="w-5 h-5" />, label: "நேரம்", value: kumbhavisekam.time },
                  { icon: <MapPin className="w-5 h-5" />, label: "இடம்", value: kumbhavisekam.location },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-4 rounded-xl px-5 py-4"
                    style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)' }}
                  >
                    <div
                      className="p-3 rounded-lg"
                      style={{ background: 'rgba(251,191,36,0.2)', color: '#fbbf24' }}
                    >
                      {item.icon}
                    </div>
                    <div>
                      <div className="text-xs font-semibold uppercase tracking-wider" style={{ color: '#93c5fd' }}>
                        {item.label}
                      </div>
                      <div
                        className="font-bold text-lg"
                        style={{ color: '#ffffff', fontFamily: "'Noto Sans Tamil', sans-serif" }}
                      >
                        {item.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <button
                onClick={() => window.open(kumbhavisekam.invitationPdf, "_blank")}
                className="w-full flex items-center justify-center gap-3 font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
                style={{ background: 'linear-gradient(to right, #f59e0b, #ea580c)', color: '#fff' }}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                அழைப்பிதழ் பதிவிறக்கம் (PDF)
              </button>
            </div>
          </div>

          {/* RIGHT: Modi Invitation Image */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden flex flex-col">
            <div
              className="px-6 py-4"
              style={{ background: 'linear-gradient(to right, #1e3a8a, #1d4ed8)' }}
            >
              <h3 className="text-xl font-bold text-white flex items-center gap-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
                பிரதமர் மோடி அவர்களுக்கு அழைப்பு
              </h3>
            </div>

            <div className="relative flex-1 overflow-hidden group min-h-[350px]">
              <img
                src={kumbhavisekam.modiImage}
                alt="PM Modi Invitation"
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              {/* <div className="absolute bottom-0 left-0 right-0 p-6">
                <div
                  className="rounded-xl px-5 py-4 text-white"
                  style={{ background: 'rgba(30, 58, 138, 0.7)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)' }}
                >
                  <p className="font-bold text-lg" style={{ fontFamily: "'Noto Sans Tamil', sans-serif" }}>
                    மாண்புமிகு பிரதமர் நரேந்திர மோடி அவர்களுக்கு
                  </p>
                  <p className="text-sm mt-1" style={{ color: '#bfdbfe', fontFamily: "'Noto Sans Tamil', sans-serif" }}>
                    அழைப்பிதழ் வழங்கப்பட்டுள்ளது
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* ===== KUMBAVISEKAM VIDEO SECTION ===== */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-10 leading-tight">
          <span className="text-amber-600">மகா கும்பாபிஷேக வீடியோ</span>
        </h1>
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
          <div className="aspect-video bg-gray-900">
            <video controls className="w-full h-full object-contain" preload="metadata">
              <source
                src="https://res.cloudinary.com/dwu5s4j0i/video/upload/v1786984511/WhatsApp_Video_2026-08-13_at_8.18.48_PM_jftlmw.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </section>

      {/* ===== HERO SECTION ===== */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          <div className="flex flex-col gap-6 items-center md:items-start">
            <div className="rounded-xl overflow-hidden shadow-lg w-full md:w-[80%]">
              <img src={kovilTop} alt="Temple 1" className="w-full h-auto" />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg w-full md:w-[80%]">
              <img src={heroImg} alt="Temple 2" className="w-full h-auto" />
            </div>
          </div>

          <div id="history" className="text-center md:text-left">
            <span className="inline-block px-4 py-1 text-sm font-semibold text-orange-800 bg-yellow-100 rounded-full mb-5">
              ஸ்ரீமன் வைகுண்ட நாராயணசுவாமி திருக்கோவில்
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-5 leading-tight">
              <span className="text-amber-600">கடவுள் வாழ்த்து</span>
            </h1>
            <ul className="text-lg text-gray-600 mb-8 leading-relaxed">
              <li>நாடான நாடதிலே நல்லபுகழ் இராச்சியத்தில்</li>
              <li>கடற்கரை வனமதிலே கடவுள் நாராயணம்</li>
              <li>எல்லோருக்கும் பொதுவாக ஈஸ்வரரே காத்தருளும்</li>
            </ul>
            <div className="flex flex-col sm:flex-row flex-wrap justify-center md:justify-start gap-3 w-full">
              {features.map((item, i) => (
                <div
                  key={i}
                  onClick={() => {
                    if (item.pdf) {
                      window.open(item.pdf, "_blank");
                    } else if (item.path) {
                      navigate(item.path);
                    }
                  }}
                  className={`${item.bg} w-full sm:w-auto flex items-center justify-start space-x-2 p-2.5 rounded-md shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer`}
                >
                  <div className="bg-white/20 p-1.5 rounded-full">{item.icon}</div>
                  <p className="text-white font-semibold text-xs sm:text-sm">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="bg-gray-50">
        <div
          className="max-w-6xl mx-auto px-6 grid gap-5"
          style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))" }}
        >
        </div>
      </section>

      {/* ===== BOOKS ===== */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-5 leading-tight">
          <span className="text-amber-600">புத்தகங்கள்</span>
        </h1>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            },
            flexWrap: "wrap",
            gap: 3,
            p: 3,
            border: '1px solid rem'
          }}
        >
          {books.map((book) => (
            <BookCard key={book.id} book={book} />
          ))}
        </Box>
      </section>

      {/* ===== AUDIO ===== */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-10 leading-tight">
          <span className="text-red-600">ஆடியோ</span>
        </h1>
        <Gallery />
      </section>

      {/* ===== EVENTS ===== */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-10 leading-tight">
          <span className="text-red-600">நிகழ்வுகள்</span>
        </h1>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative">
              <div className="absolute top-6 left-6 z-10 flex flex-wrap gap-2 max-w-[70%]">
                <button
                  onClick={() => setActiveMedia('image')}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all shadow-lg ${activeMedia === 'image'
                    ? 'bg-red-600 text-white'
                    : 'bg-white/90 backdrop-blur-sm text-gray-700 hover:bg-white'}`}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span className="text-sm">புகைப்படம்</span>
                </button>
                <button
                  onClick={() => setActiveMedia('video')}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all shadow-lg ${activeMedia === 'video'
                    ? 'bg-red-600 text-white'
                    : 'bg-white/90 backdrop-blur-sm text-gray-700 hover:bg-white'}`}
                >
                  <Play className="w-4 h-4" />
                  <span className="text-sm">வீடியோ</span>
                </button>
              </div>

              <div className="absolute top-6 right-6 z-10 bg-red-600 text-white rounded-xl px-4 py-3 shadow-lg max-sm:top-20">
                <div className="text-center">
                  <div className="text-3xl font-bold leading-none">03</div>
                  <div className="text-sm font-medium mt-1">ஆகஸ்ட்</div>
                </div>
              </div>

              <div className="relative h-80 lg:h-full min-h-[500px]">
                {activeMedia === 'image' ? (
                  <div className="relative h-full overflow-hidden group">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent lg:bg-gradient-to-r" />
                  </div>
                ) : (
                  <div className="h-full bg-gray-900">
                    <video controls className="w-full h-full object-contain" preload="metadata">
                      <source src={event.videoId} type="video/mp4" />
                      <source src={event.videoId} type="video/webm" />
                      <source src={event.videoId} type="video/ogg" />
                    </video>
                  </div>
                )}
              </div>
            </div>

            <div className="p-8 lg:p-10 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 rounded-full px-4 py-2 w-fit mb-6">
                <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse" />
                <span className="text-sm font-bold">சிறப்பு நிகழ்வு</span>
              </div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                {event.title}
              </h2>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4 group">
                  <div className="bg-red-50 rounded-lg p-3 group-hover:bg-red-100 transition-colors">
                    <Calendar className="w-5 h-5 text-red-600" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-500 mb-1">தேதி</div>
                    <div className="text-gray-900 font-semibold">{event.date}</div>
                  </div>
                </div>
                <div className="flex items-start gap-4 group">
                  <div className="bg-red-50 rounded-lg p-3 group-hover:bg-red-100 transition-colors">
                    <Clock className="w-5 h-5 text-red-600" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-500 mb-1">நேரம்</div>
                    <div className="text-gray-900 font-semibold">{event.time}</div>
                  </div>
                </div>
                <div className="flex items-start gap-4 group">
                  <div className="bg-red-50 rounded-lg p-3 group-hover:bg-red-100 transition-colors">
                    <MapPin className="w-5 h-5 text-red-600" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-500 mb-1">இடம்</div>
                    <div className="text-gray-900 font-semibold">{event.location}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>




      {/* ===== YOUTUBE SECTION ===== */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-10 leading-tight">
          <span className="text-red-600">YouTube சேனல்</span>
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
              <div className="flex items-start gap-6 mb-6">
                <div className="relative flex-shrink-0">
                  <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-red-100">
                    <img src={channel.thumbnail} alt={channel.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="absolute -bottom-1 -right-1 bg-red-600 rounded-full p-1.5">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-1">{channel.name}</h2>
                  <p className="text-gray-600">{channel.description}</p>
                </div>
              </div>
              <div className="mb-6">
                <h3 className="text-lg font-bold text-gray-900 mb-3">சேனலைப் பற்றி</h3>
                <p className="text-gray-700 leading-relaxed">{channel.about}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <div className="bg-gradient-to-r from-red-600 to-pink-600 px-6 py-4">
              <h3 className="text-xl font-bold text-white flex items-center gap-2">
                <Play className="w-5 h-5" />
                வீடியோ
              </h3>
            </div>
            <div className="aspect-video bg-gray-900 relative">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/1F7HFGNQY1A?si=HghogJDGq-C1ZURk"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
              />
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}